import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { SetThemeDirective } from './directives/set-theme.directive';

@NgModule({
  declarations: [SetThemeDirective, FeatureFlagDirective],
  imports: [CommonModule],
  exports: [SetThemeDirective, FeatureFlagDirective],
})
export class SharedDirectivesModule {}
